import { calcularTamanhoHeader } from "./utilidades/calcularTamanhoHeader";

const hotsite = {
  Internacionalizacao() {
    const selectCultures = document.querySelectorAll(".cultura");
    const culturaSelecionada = document.getElementsByClassName(
      "cultura-selecionada"
    );

    for (const botaoCultura of culturaSelecionada) {
      botaoCultura.innerHTML = document.querySelector(
        `a.cultura[data-culture="${CULTURE_EMPREGARE}"]`
      ).innerHTML;
    }

    selectCultures.forEach(
      (selectCulture) =>
        (selectCulture.onclick = (e) =>
          document
            .querySelectorAll(".cultura-selecionada")
            .forEach((dropdown) => {
              const culture = e.target.getAttribute("data-culture");
              window.location.href = window.location.href.replace(
                "/" + CULTURE_EMPREGARE,
                "/" + culture
              );
            }))
    );
  },
  AjustarPaginasQuandoLogar() {
    // Observar EventListener que e enviado do global ao logar

    window.addEventListener("LoginHotsite", (e) => {
      const navBarFiltros = document.querySelector(".navbar-filtros");
      const tamanhoHeaderAtual = calcularTamanhoHeader();

      if (!navBarFiltros) {
        document.querySelector("body").style.paddingTop = tamanhoHeaderAtual + "px";

        this.DetalhesVaga(tamanhoHeaderAtual);
      }
      else {
        const filtrosVagas =document.getElementsByClassName("navbar-filtros")[0];
        const headerPesquisa = document.querySelector("#pesquisa-cargo-hotsite");

        if(!headerPesquisa || !filtrosVagas)
          return;
        filtrosVagas.style.top = tamanhoHeaderAtual + headerPesquisa.offsetHeight + "px";
        headerPesquisa.style.top = tamanhoHeaderAtual + "px";
      }
    });
  },
  PainelCandidato() {
    const barraPainelMobile = document.querySelector("#tab-botoes");

    if (barraPainelMobile) {
      const styleElement = document.createElement("style");

      styleElement.textContent = `
      @media (max-width: 768px) {
          .tabs-botoes .link-menu-ativo {
              color: var(--bs-secondary) !important;
              border-bottom: 2px solid var(--bs-primary) !important;
          }
          .link-menu-ativo {
              background-color: white !important;
          }
      }`;

      barraPainelMobile.appendChild(styleElement);
    }
  },
  DetalhesVaga(tamanhoHeaderAtual) {
    const barraDetalheVaga = document.getElementById("navbarFixadaDetalheVaga");
    if (barraDetalheVaga) {
      barraDetalheVaga.style.top = tamanhoHeaderAtual + "px";
    }
  },
  Vagas(tamanhoHeaderAtual) {
    const filtrosVagas = document.getElementsByClassName("navbar-filtros")[0];
    const headerPesquisa = document.getElementById("pesquisa-cargo-hotsite");

    if (filtrosVagas && headerPesquisa) {
      if (window.innerWidth > 1000) {
        document.body.style.paddingTop =
          tamanhoHeaderAtual + headerPesquisa.clientHeight + 70 + `px`;

        filtrosVagas.style.zIndex = "985";

        filtrosVagas.classList.add("transicao-colapso-cabecalho");
        headerPesquisa.classList.add("transicao-colapso-cabecalho");

        const controladorHeaderColapsavel = document.getElementById(
          "TermoBuscaVagaTexto"
        );

        const callbackHeaderColpsavel = (chave) => {
          let tamanhoHeaderNovo = calcularTamanhoHeader();

          if (chave && window.innerWidth > 1000) {
            filtrosVagas.style.top =
              tamanhoHeaderNovo + headerPesquisa.offsetHeight + "px";
            headerPesquisa.style.top = tamanhoHeaderNovo + "px";
            return;
          }

          filtrosVagas.style.zIndex = 985;

          headerPesquisa.style.top =
            tamanhoHeaderNovo - headerPesquisa.offsetHeight + "px";

          filtrosVagas.style.top = tamanhoHeaderNovo + "px";
        };

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (entry.boundingClientRect.y < entry.rootBounds.y) {
                  //Elemento está acima do observador
                  callbackHeaderColpsavel(false);
                } else {
                  //Elemento está abaixo do observador
                  callbackHeaderColpsavel(true);
                }
              } else {
                // Elemento de destino não está visível
                callbackHeaderColpsavel(false);
              }
            });
          },
          { root: null, threshold: 1, rootMargin: `10px` }
        );

        observer.observe(controladorHeaderColapsavel);

        return observer;
      } else {
        document.body.style.paddingTop =
          tamanhoHeaderAtual + headerPesquisa.clientHeight + 70 + `px`;
        filtrosVagas.style.top = tamanhoHeaderAtual + "px";
      }
    }
    return null;
  },
  AjustarHeadeQuestionario() {
    const headerQuestionario = document.querySelector(".header-questionario");

    if (headerQuestionario) {
      const headersEmpregare = document.querySelectorAll(".header-empregare");

      if (headersEmpregare && headersEmpregare.length > 0) {
        headersEmpregare.forEach((header) => {
          header.classList.add("d-none");
        });
      }
    }
  },
  Main() {
    let tamanhoHeaderAtual = 0;

    this.PainelCandidato();
    this.AjustarHeadeQuestionario();

    const CustomizarLayoutVagasHotsite = () => {
      tamanhoHeaderAtual = calcularTamanhoHeader();

      this.DetalhesVaga(tamanhoHeaderAtual);

      document.querySelector("body").style.paddingTop =
        tamanhoHeaderAtual + "px";

      return this.Vagas(tamanhoHeaderAtual);
    };

    let observerInstancia = CustomizarLayoutVagasHotsite();

    window.addEventListener("resize", () => {
      if (observerInstancia != null) {
        observerInstancia.disconnect();
      }
      observerInstancia = CustomizarLayoutVagasHotsite();
    });
  },
  Init() {
    const hotsite = document.getElementById("layout-hotsite");

    if (hotsite) {
      this.AjustarPaginasQuandoLogar();
      this.Main();
      this.Internacionalizacao();
    }
  },
};

hotsite.Init();
